module.exports = __webpack_public_path__ + "img/mensaje__gris.0f3e23b3.svg";